import useSWR from 'swr';
import hash from 'object-hash';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { SWRCustomResponse } from '../../../hooks/types';
import { useMatchMutate } from '../../../utils/swr/swr';
import { getTasks, GetTasksFilters } from '../../../providers/api/task/taskProvider';
import { Task } from '../../../providers/api/dtos';
import { API_TASKS_PATH } from '../../../providers/api/api';

export default function useTasks(filters?: GetTasksFilters, pagination?: PaginationParams): SWRCustomResponse<PaginatedResult<Task>, Error> {
  const matchMutate = useMatchMutate();
  const key = [API_TASKS_PATH, hash({ ...(filters || {}), ...(pagination || {}) })];
  const result = useSWR(key, () => getTasks(filters, pagination));

  return {
    ...result,
    mutate: () => matchMutate(API_TASKS_PATH),
  };
}
